var isMobile = false;
if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) )
    isMobile = true;
else
    isMobile = false;

var wSize = window.innerWidth;
var hSize = window.innerHeight;

var announcement_height;
var announcement_isClosed = false;
var submenu_offset = 2;

$("#announcement-bar .owl-carousel").owlMarquee({
    items: 3,
    loop: true,
    nav: false,
    dots: false,
    margin: 20,
    stagePadding: 30,
    autoplay: a_autoScroll,
    slideTransition: 'linear',
    autoplayTimeout: 0,
    autoplaySpeed: 5000,
    autoplayHoverPause: false,
    responsive:{
        0: {
            items: 1,
            stagePadding: 20,
        },
        1024:{
            items: 3,
            stagePadding: 30,
        }
    }
});

if ($('#announcement-bar').length) {
    announcement_height = $('#announcement-bar').innerHeight();
    $('#header').css('top', `${announcement_height}px`);
}
else {
    $('#header').css('top', '0px');
    announcement_isClosed = true;
}

$(document).ready(function() {

    $.fn.DataTable.ext.pager.numbers_length = 5;

    $('.select2').select2();
    
    checkInputDate();

    backToTop();

    wSize = window.innerWidth;
    hSize = window.innerHeight;

    $('[data-aos]').addClass('aos-init');

    $('#header').css('transition', 'all .3s linear');

    if ($('#inner-banner').length) {
        $('#inner-banner .aos-init').addClass('aos-animate');
    }

    if (wSize >= 1920)
        submenu_offset -= 1;
    
    productPadding();
    productNav();
    productScrollSpy();

    if ($('.fbt').length) {
        function updateSelectWidth() {
            $('.fbt-select').each(function() {
                let $select = $(this);
                let maxWidth = 0;
                
                let $tempSpan = $('<span>').css({
                    visibility: 'hidden',
                    whiteSpace: 'nowrap',
                    display: 'inline-block'
                }).appendTo('body');
    
                $select.find('option:selected').each(function() {
                    $tempSpan.text($(this).text());
                    let width = $tempSpan.width();
                    if (width > maxWidth) {
                        maxWidth = width;
                    }
                });
    
                $tempSpan.remove();
                
                $select.css('width', maxWidth + 13);

                let name = $(this).attr('name').replace('select', 'item');
                let val = $(this).find(':selected').val();
                $(`input[name="${name}"]`).val(val);

                $(`.atc-form .${name}`).val(val);

                let price = $(this).attr('name').replace('select', 'price');
                let spanPrice = $(this).find(':selected').data('price');
                $(`.${price}`).html(spanPrice);
                
                let totalPrice = 0;
                let totalComparePrice = 0;

                $('.fbt-price > span').each(function(index) {
                    let text = $(this).text();
                    let value = parseFloat(text.replace(/^\$/, '').replace(/,/g, ''));
                    if (!isNaN(value)) {
                        totalPrice += value;
                    }

                    let compare_text = $(`.fbt-compare-price-${index} span`).text();
                    let compare_value = parseFloat(compare_text.replace(/^\$/, '').replace(/,/g, ''));
                    if (!isNaN(compare_value)) {
                        totalComparePrice += compare_value;
                    }
                    else {
                        totalComparePrice += value;
                    }
                });
                
                $('.fbt-total-price span').html('$'+totalPrice.toFixed(2));

                /* -------------- */

                let compare_price = $(this).attr('name').replace('select', 'compare-price');
                let compare_spanPrice = $(this).find(':selected').data('price-compare');
                $(`.${compare_price}`).html(compare_spanPrice);

                $('.fbt-price').each(function() {
                    let nextComparePrice = $(this).next('.fbt-compare-price');
                    
                    if (nextComparePrice.length && nextComparePrice.children().length > 0) {
                        $(this).addClass('f-red').removeClass('f-gray');
                    } else {
                        $(this).addClass('f-gray').removeClass('f-red');
                    }
                });

                if (totalComparePrice > 0) {
                    $('.fbt-total-compare-price span').html('$'+totalComparePrice.toFixed(2));
                }

            });
        }

        updateSelectWidth();
        $('.fbt-select').on('change', updateSelectWidth);

        $('.fbt-check:not([name="fbt-item-0"])').on('change', function() {
            let name = $(this).attr('name');
            let val = $(this).val();

            $(`.atc-form .${name}`).remove();

            if ($(this).is(':checked')) {
                $('.atc-form input[name="id"]').attr('name', 'id[]');
                $('.atc-form').append($(`<input type="hidden" class="fbt ${name}" name="id[]" value="${val}">`));
            }
            else if (!$(this).is(':checked')) {
                $(`.atc-form input.fbt[value="${val}"]`).remove();

                if ($('.atc-form input.fbt').length == 0) {
                    $('.atc-form input[name="id[]"]').attr('name', 'id');
                }
            }
        });

        $('.fbt-check[name="fbt-item-0"]').on('change', function() {
            let val = $(this).val();
            if ($(this).is(':checked')) {
                $('.atc-form .original-id').val(val);
            }
        });

        $('.fbt-atc').on('click', function() {
            $('.btn-atc').trigger('click');
        });
    }
});

function productPadding() {
    if (typeof isProduct !== 'undefined' && isProduct == true) {
        let aHeight = 0;
        if (!announcement_isClosed)
            aHeight = announcement_height;

        let hHeight = $('#header').height();

        let paddingTop = aHeight + hHeight + 30;

        $('#product-section-1 .container').css('padding-top', `${paddingTop}px`);
    }
}

function productNav() {
    if (typeof isProduct !== 'undefined' && isProduct == true) {

        let aHeight = 0;
        if (!announcement_isClosed)
            aHeight = announcement_height;
        else
            aHeight = -announcement_height;

        let hHeight = $('#header').height();

        if ($('#product-nav').length) {

            if (scrollDistance($('#product-section-1')) == -100) {
                $('#announcement-bar').css('top', `-${aHeight}px`);
                if (!announcement_isClosed)
                    $('#header').css('top', `-${hHeight+aHeight}px`);
                else
                    $('#header').css('top', `-${hHeight}px`);
            } 
            else {
                if (!announcement_isClosed) {
                    $('#announcement-bar').css('top', `0px`);
                    $('#header').css('top', `${aHeight}px`);
                }
                else {
                    $('#announcement-bar').css('top', `-${aHeight}px`);
                    $('#header').css('top', `0px`);
                }
            }

        }
    }
}

function productScrollSpy() {
    if (isProduct) {
        const sections = $('section');
        let currentSection = '';

        sections.each(function () {
            const sectionTop = $(this).offset().top - 50;
            const sectionHeight = $(this).height();
            if (window.scrollY >= sectionTop && window.scrollY < sectionTop + sectionHeight) {
                currentSection = $(this).data('anchor');
            }
        });

        const links = $('#product-nav .anchors p');
        links.removeClass('active');
        links.filter('[data-anchor="' + currentSection + '"]').addClass('active');
    }
}

$('#product-nav .anchors:not(.mobile) .anchor').click(function() {
    const targetSection = $(this).data('anchor');
    const targetOffset = $('section[data-anchor="' + targetSection + '"]').offset().top;

    $('html, body').animate({
        scrollTop: targetOffset
    }, 0);
});

$('#product-nav .btn-beelink').on('click', function() {
    $('.atc-form').trigger('submit');
});

$(window).on('resize', function(){
    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) )
        isMobile = true;
    else
        isMobile = false;
    
    wSize = window.innerWidth;
    hSize = window.innerHeight;

    if (wSize >= 1280) {
        if ($('#header .menu').css("display") === "block") {
            $('#header .toggle-menu a i').removeClass().addClass('fa-solid fa-bars');
            
            $('#header').css('height', 'auto');
            $('#header .menu').hide();

            $('html, body').css('overflow-y', 'auto');
        }
    }

    productPadding();
    productNav();
});

$(window).on('scroll', function() {
    backToTop();
    productNav();
    productScrollSpy();
});

$('#announcement-bar .announcement-close').on('click', function() {
    if ($('#announcement-bar').length) {
        $('#announcement-bar').css('top', `-${announcement_height}px`);
        $('#header').css('top', '0px');
        announcement_isClosed = true;

        if ($('#header .menu').css("display") === "block")
            $('#header').css('height', '100%');
        else
            $('#header').css('height', 'auto');

        productPadding();
    }
});

$('#announcement-bar, #header .logo img, #header .icons').on('mouseover', function() {
    megaMenu_close();
});

$('#header .nav-item').on('mouseover', function() {

    megaMenu_close();

    if ($(this).children('.nav-dropdown').length > 0) {

        let hHeight = $('#header').innerHeight();
        let aHeight = $('#header .nav-item > a').innerHeight();

        let pTop = (((hHeight/2)+(aHeight/2))-aHeight)+submenu_offset;
        
        $(this).children('.nav-dropdown').css('top', `${aHeight}px`);
        $(this).children('.nav-dropdown').css('padding-top', `${pTop}px`);
        
        $(this).children('.nav-dropdown').show();
    }
    else {
        if ($(this).children('[data-mega]').length > 0) {
            let mm = $(this).children('[data-mega]').data('mega');
            megaMenu_open(mm);
        }
    }

}).on('mouseleave', function() {

    if ($(this).children('.nav-dropdown').length > 0) {
        $(this).children('.nav-dropdown').hide();
    }

});

$('#mega-menu').on('mouseleave', function() {
    megaMenu_close();
});

function megaMenu_open(mm) {
    let aHeight = 0;
    if (!announcement_isClosed)
        aHeight = $('#announcement-bar').innerHeight();
    
    let hHeight = $('#header').innerHeight();
    

    let mTop = hHeight + aHeight;

    $(`#mega-menu [data-selector="${mm}"]`).addClass('show');
    
    let count = $('.mega-selector').filter(function() {
        return $(this).hasClass('show');
    }).length;

    if (count > 0) {
        $('#mega-menu').css('top', `${mTop}px`).show();
        $('#mega-menu .mega-selector.show').each(function(index) {
            if (index % 2 === 0) {
                $(this).addClass('even');
            } else {
                $(this).addClass('odd');
            }
        });

        $(`#header .nav-items .nav-item > a[data-mega="${mm}"]`).addClass('active');
    }
    else
        megaMenu_close();
}

function megaMenu_close() {
    if ($('#mega-menu').css('display') === 'block') {
        $('#mega-menu').hide();
        $('#mega-menu .mega-selector').removeClass('show');
        $('#mega-menu .mega-selector').removeClass('even');
        $('#mega-menu .mega-selector').removeClass('odd');
        $(`#header .nav-items .nav-item > a`).removeClass('active');
    }
}

$('.back-to-top').click(function () {
    $('html, body').animate({ scrollTop: 0 }, 'fast');
});

function checkInputDate() {
    if ($('input[type="date"]').val() == '')
        $('input[type="date"]').css('color', '#707070');
    else
        $('input[type="date"]').css('color', '#323232');
}

$('input[type="date').on('keyup', function() {
    checkInputDate();
}).on('change', function() {
    checkInputDate();
});

$('#header .toggle-menu a').on('click', function() {
    if ($('i', this).attr('class') == 'fa-solid fa-bars') {

        //open

        $('i', this).removeClass().addClass('fa-solid fa-xmark');

        let aHeight = 0;
        if (!announcement_isClosed)
            aHeight = $('#announcement-bar').innerHeight();
        
        $('#header').css('height', `calc(100% - ${aHeight}px)`);
        $('#header .menu').show();

        $('html, body').css('overflow-y', 'hidden');
    }
    else {

        //close

        $('i', this).removeClass().addClass('fa-solid fa-bars');
        
        $('#header').css('height', 'auto');
        $('#header .menu').hide();

        $('html, body').css('overflow-y', 'auto');
    }
});

$('a.accordion-button').on('click', function() {
    window.location.href = $(this).attr('href');
});

function backToTop() {
    let scrollDistance = $(window).scrollTop();

    let vh50 = $(window).height() * 0.5;

    if (wSize >= 1280) {
        if (scrollDistance >= vh50) {
            $('.back-to-top').css('opacity', '1');
        }
        else {
            $('.back-to-top').css('opacity', '0');
        }
    }
}

$('.back-to-top').on('transitionend webkitTransitionEnd oTransitionEnd', function () {
    if ($(this).css('opacity') == 1)
        $(this).css('pointer-events', 'all');
    else
        $(this).css('pointer-events', 'none');
});

function visiblePercent($element) {
    let windowHeight = $(window).height();
    let scrollTop = $(window).scrollTop();
    let elementOffset = $element.offset().top;
    let elementHeight = $element.outerHeight();

    let distanceFromTop = elementOffset - scrollTop;
    let visiblePercent = (windowHeight - distanceFromTop) / elementHeight * 100;

    visiblePercent = Math.max(0, Math.min(100, visiblePercent));

    return visiblePercent;
}

function isElementInView(elementSelector) {
    let boxTop = $(elementSelector).offset().top;
    let boxBottom = boxTop + $(elementSelector).outerHeight();
    let viewportTop = $(window).scrollTop();
    let viewportBottom = viewportTop + $(window).height();

    return boxTop < viewportBottom && boxBottom > viewportTop;
}

function isInFull($element) {
    let elementTop = $element.offset().top;
    let elementBottom = elementTop + $element.outerHeight();
    let viewportTop = $(window).scrollTop();
    let viewportBottom = viewportTop + $(window).height();

    let isFullyVisible = elementTop >= viewportTop && elementBottom <= viewportBottom;
    let isPartiallyVisibleTop = elementTop < viewportTop && elementBottom > viewportTop;
    let isPartiallyVisibleBottom = elementTop < viewportBottom && elementBottom > viewportBottom;

    if (isFullyVisible || (isPartiallyVisibleTop && isPartiallyVisibleBottom))
        return 'full';
    else if (isPartiallyVisibleTop)
        return 'partial-top';
    else if (isPartiallyVisibleBottom)
        return 'partial-bottom';
    else
        return 'none';
}

function calculateScrollPercentage($element) {
    let windowHeight = $(window).height();
    let scrollTop = $(window).scrollTop();
    let elementOffset = $element.offset().top;
    let elementHeight = $element.height();

    // Calculate the percentage of the element visible in the viewport
    let visiblePercentage = Math.max(0, Math.min(100, ((scrollTop + windowHeight - elementOffset) / elementHeight) * 100));

    return visiblePercentage;
}

function scrollDistance($element) {
    let windowHeight = $(window).height();
    let scrollTop = $(window).scrollTop();
    let elementOffset = $element.offset().top;
    let elementHeight = $element.height();

    // Calculate the distance of the element from the top of the viewport
    let distanceFromTop = elementOffset - scrollTop;

    // Calculate the percentage of the element visible in the viewport
    let visiblePercentage;

    if (distanceFromTop >= 0) {
        // Element is fully visible at the top of the viewport
        visiblePercentage = 100;
    } else if (distanceFromTop <= -elementHeight) {
        // Scroll has passed the element completely
        visiblePercentage = -100;
    } else {
        // Element is partially visible
        visiblePercentage = Math.round((1 + distanceFromTop / elementHeight) * 100);
    }

    return visiblePercentage;
}


$('#header .nav-search').on('click', function(event) {
    event.stopPropagation();
    $('#header .container.search').show();
});

$('#header .close-search').on('click', function() {
    $('#header .container.search').hide();
    $('#header .container.search form').trigger('reset');
    $('#header .container.search #predictive-search').hide();
});

$(document).on('click', function(event) {
    let container = $('#header .container.search');
    if (container.css('display') === 'block' && !container.is(event.target) && container.has(event.target).length === 0) {
        $('#header .container.search').hide();
        $('#header .container.search form').trigger('reset');
        $('#header .container.search #predictive-search').hide();
    }
});

$('#faq-section-1 .faq-toggles button').on('click', function() {
    $(this).addClass('active').siblings().removeClass('active');

    let toggle = $(this).data('toggle');

    $(`#faq-section-1 .nav-toggle[data-nav="${toggle}"]`).addClass('active').siblings().removeClass('active');
});

var fbtInterval;

$(document).on('click', '.ppcse-tot-btn-div', function() {
    setTimeout(() => {
        fbtInterval = setInterval(monitorChanges, 500);
    }, 10);
});

function monitorChanges() {
    if ($('.ppcse-tot-btn-div').find('svg').length === 0) {
        openCart();
        refreshCart();
        clearInterval(fbtInterval);
    }
}
